import React from 'react';
import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  VenueService,
  BarService,
  RoleService,
  ProductService,
  CategoryService,
  TeamService,
  MembershipService,
  ProductCategoryService,
  IngredientService,
  DateService,
} from '../../services';
import { Converter } from '../../utils';

// !! VALUE MUST HAVE NAME PROPERTY
// !! TYPE MUST BE VALID COLLECTION NAME ['venues', 'bars', 'roles', 'products', 'categories', 'teams', 'memberships', 'product_categories', 'ingredients', 'date_ranges', 'terminals']

class Select extends React.Component {
  constructor(props) {
    super(props);

    const { defaultValue, type } = this.props;

    this.state = {
      loading: false,
      typing: false,
      typingTimeout: 0,
      showDropDown: false,
      searchText: defaultValue ? this.selectValue(defaultValue) : '',
      data: [],
      selectedValue: defaultValue ? defaultValue : null,
    };

    this.reset = this.reset.bind(this);
    this.setValue = this.setValue.bind(this);
    this.selectValue = this.selectValue.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.fetchList = this.fetchList.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onSearchKeyUp = this.onSearchKeyUp.bind(this);
    this.onOptionChange = this.onOptionChange.bind(this);

    // SET SERVICE
    this.service = null;

    switch (type) {
      case 'venues':
        this.service = new VenueService();
        break;
      case 'bars':
        this.service = new BarService();
        break;
      case 'roles':
        this.service = new RoleService();
        break;
      case 'products':
        this.service = new ProductService();
        break;
      case 'categories':
        this.service = new CategoryService();
        break;
      case 'teams':
        this.service = new TeamService();
        break;
      case 'memberships':
        this.service = new MembershipService();
        break;
      case 'product_categories':
        this.service = new ProductCategoryService();
        break;
      case 'ingredients':
        this.service = new IngredientService();
        break;
      case 'date_ranges':
        this.service = new DateService();
        break;
      case 'terminals':
        this.service = new VenueService();
        break;
      default:
        this.service = new VenueService();
        break;
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick);

    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  reset() {
    this.setState({
      loading: false,
      typing: false,
      typingTimeout: 0,
      showDropDown: false,
      searchText: '',
      data: [],
      selectedValue: null,
    });
  }

  setValue(value) {
    this.setState({ searchText: value });
  }

  selectValue(value) {
    const { capitalize, field } = this.props;

    value = field ? value[field] : value;

    return capitalize ? Converter.capitalize(value) : value;
  }

  handleClick(e) {
    const id = e.target.id;
    const { selectedValue, searchText } = this.state;
    const { renderNoResult } = this.props;
    const lastText = selectedValue ? this.selectValue(selectedValue) : searchText;

    if (!this.node.contains(e.target) && id !== 'select-dropdown' && !(renderNoResult && e.target.className === renderNoResult.props.className)) {
      this.setState({ showDropDown: false, searchText: lastText });
    }
  }

  fetchList(clear = false) {
    const { searchText } = this.state;
    const { type, query, method } = this.props;

    this.setState({ searchText: clear ? '' : searchText, showDropDown: true, loading: true }, async () => {
      const result = await this.service[method]({ search: clear ? '' : searchText, show_inactives: false, ...query });

      if (result && result.success) {
        this.setState({ data: result[type], loading: false });
      } else if (result && result.ecode === 214) {
        this.setState({ data: [], loading: false });
      }
    });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
  }

  onSearchKeyUp() {
    const { typingTimeout } = this.state;

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    this.setState({
      typing: false,
      typingTimeout: setTimeout(() => {
        this.fetchList();
      }, 500),
    });
  }

  onOptionChange(row) {
    const { onChange } = this.props;

    if (row) {
      this.setState({ searchText: this.selectValue(row), selectedValue: row, showDropDown: false }, () => {
        onChange(row);
      });
    }
  }

  render() {
    const { loading, showDropDown, data, searchText } = this.state;
    const { t, fullWidth, translate, label, size, iconField, error, errorText, disabled, renderNoResult } = this.props;

    return (
      <div className={`outlined-textfield ${size} ${error && 'outlined-textfield-error'}`} style={{ width: fullWidth ? '100%' : 'auto' }}>
        <input
          ref={(ref) => (this.node = ref)}
          className={`${size}`}
          placeholder=' '
          autoComplete='off'
          disabled={disabled}
          value={searchText || ''}
          onClick={() => {
            this.fetchList(true);
          }}
          onChange={this.onSearchChange}
          onKeyUp={this.onSearchKeyUp}
        />
        <label className={`${size}`}>{label}</label>
        {error && <span className='outlined-textfield-error-text'>{errorText}</span>}
        {showDropDown &&
          (loading ? (
            <div className='dropdown-loading'>
              <div className='margin-auto'>
                <ReactLoading type='spin' color='#000' height='24px' width='24px' />
              </div>
            </div>
          ) : (
            <div className='dropdown-content'>
              <div className='dropdown-content-wrapper'>
                {data.length === 0 && (
                  <div
                    id='dropdown-content-span-no-found'
                    className='dropdown-content-span-no-found'
                    onClick={() => {
                      this.setState({ showDropDown: false });
                    }}
                  >
                    {renderNoResult ? renderNoResult : t('No Data Found')}
                  </div>
                )}
                {data.map((row, index) => {
                  const key = row._id || row.id || `${index}_ix_select`;
                  const name = this.selectValue(row);
                  const icon = iconField ? row[iconField] : null;

                  return (
                    <span
                      id='select-dropdown'
                      className='dropdown-content-span'
                      key={key}
                      onClick={() => {
                        this.onOptionChange(row);
                      }}
                    >
                      {icon ? <img className='select-dropdown-img' src={icon} alt='' /> : ''}
                      {name && name.length > 0 ? (translate ? t(name) : name) : t('None')}
                    </span>
                  );
                })}
              </div>
            </div>
          ))}
      </div>
    );
  }
}

Select.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.oneOf(['venues', 'bars', 'roles', 'products', 'categories', 'teams', 'memberships', 'product_categories', 'ingredients', 'date_ranges', 'terminals']),
  translate: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  field: PropTypes.string,
  query: PropTypes.object,
  iconField: PropTypes.string,
  method: PropTypes.string,
  renderNoResult: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
};

Select.defaultProps = {
  translate: false,
  size: 'md',
  type: 'venues',
  field: null,
  query: null,
  iconField: null,
  method: 'get',
};

export default withTranslation()(Select);
